import { render, staticRenderFns } from "./RegisterPartnerNation.vue?vue&type=template&id=3bc14d90&scoped=true"
import script from "./RegisterPartnerNation.vue?vue&type=script&lang=js"
export * from "./RegisterPartnerNation.vue?vue&type=script&lang=js"
import style0 from "./RegisterPartnerNation.vue?vue&type=style&index=0&id=3bc14d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc14d90",
  null
  
)

export default component.exports